// Module
var code = "<long-graph class=\"full-size\" long-report=\"longData\"></long-graph>\n\n";
// Exports
module.exports = code;